module.exports = __webpack_public_path__ + "static/media/proj1.d4893903.png";